import { createContext, useContext, useEffect, useReducer } from "react";
import reducer from "../reducer/cart_reducer";
import { useAuthStore } from "../store/store"; // Update the path as needed

const CartContext = createContext();

// Load cart from localStorage for a specific user
const loadCartForUser = (username) => {
  if (!username) return [];
  try {
    const cart = localStorage.getItem(`cart_${username}`);
    const parsed = JSON.parse(cart);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const initialState = {
  cart: [],
  total_item: 0,
  total_price: 0,
  shippingCharges: 850,
};

const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const username = useAuthStore((state) => state.auth.username);
  const isLoggedIn = useAuthStore((state) => state.auth.isLoggedIn);

  // 🟢 Load user's cart when they log in
  useEffect(() => {
    if (username && isLoggedIn) {
      const cartData = loadCartForUser(username);
      dispatch({ type: "load_cart", payload: cartData });
    } else {
      dispatch({ type: "clear_cart" });
    }
  }, [username, isLoggedIn]);

  // 🟢 Save cart to localStorage when cart or user changes
  useEffect(() => {
    dispatch({ type: "cart_item_price_total" });
    if (username && isLoggedIn) {
      localStorage.setItem(`cart_${username}`, JSON.stringify(state.cart));
    }
  }, [state.cart, username, isLoggedIn]);

  // Cart Actions
  const addToCart = (productId,SKU, price, Item, main, quantity, products) => {
    dispatch({
      type: "add_to_cart",
      payload: {productId,SKU, price, Item, main, quantity, products },
    });
  };

  const setDecrease = (SKU) =>
    dispatch({ type: "set_decrement", payload: SKU });

  const setIncrease = (SKU) =>
    dispatch({ type: "set_increment", payload: SKU });

  const removeItem = (SKU) =>
    dispatch({ type: "remove_item", payload: SKU });

  const clearCart = () => dispatch({ type: "clear_cart" });

  const updateQuantity = (SKU, newQty) =>
  dispatch({ type: "update_quantity", payload: { SKU, newQty } });
  

  return (
    <CartContext.Provider
      value={{
        ...state,
        addToCart,
        removeItem,
        clearCart,
        setDecrease,
        setIncrease,
        updateQuantity
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

const useCartContext = () => useContext(CartContext);

export { CartProvider, useCartContext };
